import { gql } from '@apollo/client';

export const loginMutation = gql`
  mutation login {
    loginResponse(input: $input) @rest(type: "ResponseLogin", path: "/customers/validate", method: "POST") {
      token
      cantidadMaximaInvitados
    }
  }
`;
